import * as admin from "./admin/index";
/* 
import * as adminPbl from "./admin-pbl/index";

enum AppType {
  ADMIN = "admin",
  ADMIN_PBL = "adminPbl",
  CLIENT = "client",
  CLIENT_PBL = "clientPbl",
}

const appType = import.meta.env.VITE_APP_TYPE as AppType;
 */
/** Base 객체 */
export const Base = {
  Button: admin.BaseButton,
  Checkbox: admin.BaseCheckbox,
  DateInput: admin.BaseDateInput,
  ExcelDown: admin.BaseExcelDown,
  File: admin.BaseFile,
  Input: admin.BaseInput,
  Popup: admin.BasePopup,
  Radio: admin.BaseRadio,
  SearchForm: admin.BaseSearchForm,
  Select: admin.BaseSelect,
  Tab: admin.BaseTab,
  Table: admin.BaseTable,
  TimeInput: admin.BaseTimeInput,
  TinyEditor: admin.BaseTinyEditor,
  ToggleSwitch: admin.BaseToggleSwitch,
  TableConfig: admin.BaseTableConfig,
};
